module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "toc"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/illustration#ill"
    }
  }, [_vm._v("List of Illustrations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/map#map"
    }
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/intro#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt1"
    }
  }, [_vm._v("One: Natural Nile: Beasts and beginnings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two: Ancient Nile: Famine, pestilence and a severed penis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three: River of the Believers: Madness and mystics")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part4#pt4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four: The Nile Extended: Raw steak and Napoleon")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part5#pt5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five: The Nile Damned: Elephants, exploration and Agatha Christie’s trunk")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part6#pt6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six: Blood on the Nile: From assassination to revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bot"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#ep",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bib#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Very Select Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ack#ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#ind",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Robert Twigger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0